import { render, staticRenderFns } from "./Besonderheiten.vue?vue&type=template&id=73e0f1e6&scoped=true&"
import script from "./Besonderheiten.vue?vue&type=script&lang=js&"
export * from "./Besonderheiten.vue?vue&type=script&lang=js&"
import style0 from "./Besonderheiten.vue?vue&type=style&index=0&id=73e0f1e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e0f1e6",
  null
  
)

export default component.exports